import React, { useContext } from "react";
import Photo from "./items/Photo";

import { AuthContext } from "../context/AuthContext";

function Breadcrumb({ title }) {
  const { userData } = useContext(AuthContext);
  return (
    <div className="breadcrumb divContent darktextColor darkdivColor ">
      <h5 className="textTitle">{title}</h5>
      <div className="profile text">
        <span>{userData.username}</span>
        <div className="box-pic-res">
          <Photo />
        </div>
      </div>
    </div>
  );
}

export default Breadcrumb;
